<template>
  <div>
    <DataTable ref="dataTable" :columns="columnList" defaultColumnOrderDir="DESC" :defaultColumnOrderIndex="8" :url="dataURL" :filterOptions="orderFilterOptions" :displayTools="true" :hasDateRangeFilter="true" :displayExportTools="true" exportTitle="Orders" :useQueryData="useQueryData" :debounceTime="300">
      <template v-slot:title>
        <slot name="title" />
      </template>
      <template v-slot:tools>
        <slot name="tools" />
      </template>
      <template v-slot:row="row">
        <tr :key="row.data.id">
          <td class="table-data-nav-link">
            <LinkOrder :name="row.data.sequenceNumber ? '#'+row.data.sequenceNumber : 'Pending'" :id="row.data.id" :newTab="openNewTab" />
          </td>
          <td>
            {{row.data.contactName}}
          </td>
          <td>
            {{row.data.customerRef | formatHyphenEmptyValue}}
          </td>
          <td>
            <LabelBadge :labelClass="`label-order-type-${row.data.type}`">{{row.data.type | formatLookupName(OrderTypeLookup)}}</LabelBadge>
          </td>
          <td>
            <LabelOrderStatusBadge
              :status="row.data.status"
              :isOnHold="row.data.isOnHold"
              :holdType="row.data.holdType"
              :isUrgent="row.data.isUrgent"
              :isInvoicingComplete="row.data.isInvoicingComplete"
              :isActiveTasksAssigned="row.data.isActiveTasksAssigned"
            />
          </td>
          <td>
            <LabelBadge :labelClass="`label-credit-type-${row.data.orderPaymentType}`">{{row.data.orderPaymentType | formatLookupName(OrderPaymentTypeLookup)}}</LabelBadge>
          </td>
          <td>
            <LabelDespatchBadge :type="row.data.despatchType" />
          </td>
          <td>
            <LabelTags v-if="row.data.despatchType == DespatchTypes.delivery" :labelList="row.data.deliveryTag" class="d-inline-block" />
          </td>
          <td>{{row.data.dateOrderCreated | formatDateTime}}</td>
          <td>{{row.data.dateCurrentlyDue | formatDateTime}}</td>
          <td>
            <LinkUser :id="row.data.requestUserId" :name="row.data.requestUserName" />
          </td>
          <td>{{row.data.totalPrice | formatCurrency}}</td>
          <td>
            <FormButton class="btn-default btn-xxs" @click="viewOrderProductionSummary($event, row.data.id)"><i class="far fa-info-circle" /></FormButton>
          </td>
        </tr>
      </template>
      <template v-slot:summary="summary">
        <tr key="summary">
          <td>Totals</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{summary.data.totalOrderPrice | formatCurrency}}</td>
          <td></td>
        </tr>
      </template>
    </DataTable>

    <OrderProductionSummaryPopover ref="orderSummaryPopover" />
  </div>
</template>

<script>
import _ from 'lodash'
import Utils from '@/utils/utils'

import LabelOrderStatusBadge from '@/modules/orders/components/labelOrderStatusBadge'
import OrderProductionSummaryPopover from '@/modules/orders/components/orderProductionSummaryPopover'

import { OrderTypes, OrderTypeLookup, OrderStatusTypes, OrderStatusTypeLookup, DespatchTypes, OrderHoldTypes, OrderHoldTypeLookup, OrderPaymentTypes, OrderPaymentTypeLookup } from '@/store/types'

export default {
  name: "OrderDataTable",
  components: {
    LabelOrderStatusBadge,
    OrderProductionSummaryPopover
  },
  props: {
    openNewTab: {
      type: Boolean,
      default: false
    },
    useQueryData: Boolean,
    filterContactId: Number,
    filterType: String
  },
  created() {
    this.OrderTypeLookup = OrderTypeLookup
    this.OrderStatusTypeLookup = OrderStatusTypeLookup
    this.DespatchTypes = DespatchTypes
    this.OrderHoldTypes = OrderHoldTypes
    this.OrderHoldTypeLookup = OrderHoldTypeLookup
    this.OrderPaymentTypeLookup = OrderPaymentTypeLookup
  },
  computed: {
    title() {
      return this.$route.meta.title
    },
    dataURL() {
      var params = {
        filter: {},
        includesummary: true
      }
      if(this.filterType)
        params.filter.type = this.filterType
      if(this.filterContactId)
        params.filter.contactId = this.filterContactId
      

      return '/orders?' + $.param(params)
    },
    orderFilterOptions() {
      var filterOptions = [
        {
          field: 'status',
          name: 'Status',
          options: [
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.draft), value: OrderStatusTypes.draft, class: 'label-order-status-draft' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.pendingAccountApproval), value: OrderStatusTypes.pendingAccountApproval, class: 'label-order-status-pendingAccountApproval' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.pendingProductionApproval), value: OrderStatusTypes.pendingProductionApproval, class: 'label-order-status-pendingProductionApproval' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.quotePendingSent), value: OrderStatusTypes.quotePendingSent, class: 'label-order-status-quotePendingSent' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.pendingCustomerApproval), value: OrderStatusTypes.pendingCustomerApproval, class: 'label-order-status-pendingCustomerApproval' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.pendingPrePaid), value: OrderStatusTypes.pendingPrePaid, class: 'label-order-status-pendingPrePaid' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.pendingExternalSetup), value: OrderStatusTypes.pendingExternalSetup, class: 'label-order-status-pendingExternalSetup' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.preProduction), value: OrderStatusTypes.preProduction, class: 'label-order-status-preProduction' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.production), value: OrderStatusTypes.production, class: 'label-order-status-production' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.pendingCODPaid), value: OrderStatusTypes.pendingCODPaid, class: 'label-order-status-pendingCODPaid' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.despatch), value: OrderStatusTypes.despatch, class: 'label-order-status-despatch' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.ncrPendingReturn), value: OrderStatusTypes.ncrPendingReturn, class: 'label-order-status-ncrPendingReturn' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.completed), value: OrderStatusTypes.completed, class: 'label-order-status-completed' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.denied), value: OrderStatusTypes.denied, class: 'label-order-status-denied' },
            { name: Utils.getLookupName(OrderStatusTypeLookup, OrderStatusTypes.cancelled), value: OrderStatusTypes.cancelled, class: 'label-order-status-cancelled' }            
          ]
        },
        {
          field: 'type',
          name: 'Type',
          columnIndex: 1,
          options: [
            { name: 'Quote', value: OrderTypes.quote, class: 'label-order-type-quote' },
            { name: 'Order', value: OrderTypes.order, class: 'label-order-type-order' },
            { name: 'NCR', value: OrderTypes.nonChargeableRework, class: 'label-order-type-nonChargeableRework' }
          ]
        },
        {
          field: 'despatchType',
          name: 'Despatch Type',
          columnIndex: 1,
          options: [
            { name: 'Delivery', value: 'delivery', class: 'label-despatch-badge', icon: 'fa-truck' },
            { name: 'Pickup', value: 'pickup', class: 'label-despatch-badge', icon: 'fa-person-carry' }
          ]
        },
        {
          field: 'isOnHold',
          name: 'Hold',
          columnIndex: 1,
          options: [
            { name: 'On Hold', value: 1, class: 'label-order-hold' },
          ]
        },
        {
          field: 'holdType',
          name: 'Hold Type',
          columnIndex: 1,
          options: [
            { name: 'Customer Requested', value: OrderHoldTypes.customer, class: 'label-order-hold-customer' },
            { name: 'Order Editing', value: OrderHoldTypes.orderEditing, class: 'label-order-hold-orderEditing' },
            { name: 'Accounts Hold', value: OrderHoldTypes.accounts, class: 'label-order-hold-accounts' },
            { name: 'Stock Hold', value: OrderHoldTypes.stock, class: 'label-order-hold-stock' },
            { name: 'Production Hold', value: OrderHoldTypes.production, class: 'label-order-hold-production' }
          ],
          additionalFilters: {
            isOnHold: 1
          }
        },
        {
          field: 'orderPaymentType',
          name: 'Payment Type',
          columnIndex: 2,
          options: [
            { name: Utils.getLookupName(OrderPaymentTypeLookup, OrderPaymentTypes.prepaid), value: OrderPaymentTypes.prepaid, class: 'label-credit-type-prepaid' },
            { name: Utils.getLookupName(OrderPaymentTypeLookup, OrderPaymentTypes.cod), value: OrderPaymentTypes.cod, class: 'label-credit-type-cod' },
            { name: Utils.getLookupName(OrderPaymentTypeLookup, OrderPaymentTypes.account), value: OrderPaymentTypes.account, class: 'label-credit-type-account' },
          ]
        },
        {
          field: 'isUrgent',
          name: 'Urgent',
          columnIndex: 2,
          options: [
            { name: 'Urgent', value: '1', class: 'label-order-urgent' }
          ]
        },
        {
          field: 'isInvoicingComplete',
          name: 'Invoiced',
          columnIndex: 2,
          options: [
            { name: 'Invoiced', value: '1', class: 'label-order-invoiced' }
          ],
          // Only show non-completed orders
          additionalFilters: {
            status: [OrderStatusTypes.preProduction, OrderStatusTypes.production, OrderStatusTypes.pendingCODPaid, OrderStatusTypes.despatch, OrderStatusTypes.ncrPendingReturn],
          }
        },
        {
          field: 'isActiveTasksAssigned',
          name: 'Tasks Assigned',
          columnIndex: 2,
          options: [
            { name: 'Tasks Assigned', value: '1', class: 'label-order-tasks-assigned' }
          ]
        }
      ]

      let deliveryTagLabels = this.$store.getters['label/getLabelsByType']('contactAddressDelivery')
      let onsiteDeliveryOption = [{ name: 'Onsite', value: 'onsite', colour: this.$glass.orderOnsiteLabelColour }]
      filterOptions.push({
        name: 'Delivery Tag',
        field: 'deliveryTagName',   // The extracted 'name' component from the order delivery tag
        columnIndex: 2,
        options: _.concat(
          deliveryTagLabels.map(labelInfo => {
            return {
              name: labelInfo.name,
              value: labelInfo.name,
              colour: labelInfo.colour
            }
          }),
          onsiteDeliveryOption
        )
      })

      return filterOptions
    }
  },
  data() {
    return {
      breadcrumbs: [
        { title: 'Order', link: '/orders'}
      ],
      columnList: [
        { title: "Number", data: "sequenceNumber" },
        { title: "Contact", data: "contactName" },
        { title: "Reference No.", data: "customerRef" },
        { title: "Type", data: "type" },
        { title: "Status", data: "status" },
        { title: "Payment Type", data: "orderPaymentType" },
        { title: "Despatch", data: "despatchType" },
        { title: "Delivery Tag", data: "deliveryTag" },
        { title: "Created", data: "dateOrderCreated", dateFilter: true, type: 'datetime' },
        { title: "Estimated Completion", data: "dateCurrentlyDue", dateFilter: true, type: 'datetime' },
        { title: "User", data: "requestUserName" },
        { title: "Total", data: "totalPrice", type: 'currency', totalField: 'totalOrderPrice' },
        { title: "Info", data: "", sortable: false, export: false },
      ]
    }
  },
  mounted() {
    this.requestFilterLabels()
  },
  methods: {
    reload() {
      this.$refs.dataTable.reload()
    },
    requestFilterLabels() {
      return new Promise(async (resolve, reject) => {
        try {
          // Get the label info for the filter popovers
          let deliveryTagLabels = await this.$apiService.coreService.getLabelsForType('contactAddressDelivery')
          this.$store.commit({
            type: 'label/updateLabels',
            labelType: 'contactAddressDelivery',
            labelList: deliveryTagLabels.data
          })

          return resolve()
        } catch(err) {
          return reject(err)
        }
      })      
    },
    viewOrderProductionSummary(ev, orderId) {
      this.$refs.orderSummaryPopover.displayFromElement(ev.target, orderId)
    }
  }
};
</script>
